<template>
  <div>
    <v-card class="card" v-for="schedule in resp" :key="schedule.id">
      <v-card-title> Rubrik:{{ schedule.title }}</v-card-title>
      <v-card-subtitle>Plats: {{ schedule.location }}</v-card-subtitle>
      <v-card-text>Beskrivning: {{ schedule.description }}</v-card-text>
      <v-btn
        text
        @click="
          () => {
            $router.replace(`/showschedule/${schedule.id}`);
          }
        "
        ><v-icon>fas fa-arrow-right</v-icon></v-btn
      >
    </v-card>
  </div>
</template>

<script>
import store from "../../../store";
import axios from "axios";
export default {
  data: function() {
    return {
      store: store,
      resp: null,
    };
  },
  created: async function() {
    var config = {
      method: "get",
      url: `${this.store.state.baseURL}incomingschedules/${this.store.state.user.id}`,
      headers: {
        "Content-Type": "application/form-data;charset=utf-8",
        "Access-Control-Allow-Origin": "*",
        Accept: "*/*",
      },
    };
    let resp = await axios(config);
    this.resp = resp.data.schedule;
  },
  methods: {},
};
</script>

<style scoped>
.card {
  width: relative;
  height: relative;
  padding: 10px;
  margin: 20px;
  margin-left: 0;
}
</style>
